import { useSelector } from 'react-redux';
import {
  selectCurrentPicklistData,
  selectCountingData,
  selectPicklistStatusesData,
  selectPicklistAssetsData,
  selectPicklistLooseItemsData,
  selectFilterData,
  selectFilterChipsData,
  selectFilterCriteriaData,
  selectPicklistAssembliesData
} from 'pages/PicklistAndLeavelist/PicklistSummary/PicklistDetailed/selectors';

export function usePicklistDetailsSelector() {
  const currentPicklist = useSelector(selectCurrentPicklistData());

  const assetsCounting = useSelector(selectCountingData());

  const picklistStatuses = useSelector(selectPicklistStatusesData());

  const assets = useSelector(selectPicklistAssetsData());
  const looseItems = useSelector(selectPicklistLooseItemsData());
  const assemblies = useSelector(selectPicklistAssembliesData());

  const filter = useSelector(selectFilterData());
  const chips = useSelector(selectFilterChipsData());
  const criteria = useSelector(selectFilterCriteriaData());

  return {
    currentPicklist,
    assetsCounting,
    picklistStatuses,
    assets,
    looseItems,
    assemblies,
    filter,
    chips,
    criteria
  };
}
